<template>
    <div>
        <h4 class="fw-b mb-24">{{ $t('pages.profile.habit_settings')}}</h4>
        <h6 class="fw-b"> {{ $t('pages.profile.habits_consumption') }}</h6>

        <el-form @submit="submit">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="row form-content pb-0">
                    <el-habits class="col-12 mb-16" v-model="data"></el-habits>
                </div>
            </template>

            <template slot="footer">
                <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex mr-auto mb-32" v-bind:class="{ disabled : loading  }">
                    {{ $t('general.save') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>
    </div>
</template>

<script>
import { ElHabits, ElForm, ElError } from '@/components/forms'

export default {
    name: 'admin-patient-habits',

    components: { ElHabits, ElForm, ElError },

    props: {
        patientId: {
            required: true
        },
        habitId: {
            required: true
        }
    },

    data: function() {
        return {
            loading: false,
            success: false,
            server_error: null,
            update: false,

            habit_id: null,
            data: {
                last_caffeine: null,
                last_sugar: null,
                recreation_before_sleep: null,
                notification_check_after_awaken: null,
                consumptions: []
            }
        }
    },
    mounted() {
        if (this.habitId)
            this.$store.dispatch('user/readHabitsInfo', { user_id: this.patientId, id: this.habitId }).then((habitsInfo) => {
                this.habit_id = habitsInfo.id
                let data = {}

                data.last_caffeine = habitsInfo.last_caffeine ? this.$moment(habitsInfo.last_caffeine, 'HH:mm:ss').format('HH:mm') : null
                data.last_sugar = habitsInfo.last_sugar ? this.$moment(habitsInfo.last_sugar, 'HH:mm:ss').format('HH:mm') : null
                data.recreation_before_sleep = habitsInfo.recreation_before_sleep ? this.$moment(habitsInfo.recreation_before_sleep, 'HH:mm:ss').format('HH:mm') : null
                data.notification_check_after_awaken = habitsInfo.notification_check_after_awaken ? this.$moment(habitsInfo.notification_check_after_awaken, 'HH:mm:ss').format('HH:mm') : null
                data.consumptions = habitsInfo.consumptions
                this.$set(this, 'data', data)
                this.update = true
            })
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    this.data.id = this.habit_id
                    let user_id = this.patientId
                    this.$store.dispatch(`user/${!this.update ? 'createHabitsInfo' : 'updateHabitsInfo'}`, { user_id, data: this.data }).then(
                        () => {
                            this.loading = false
                            this.success = true
                            this.$toasted.global.info({
                                title: this.$t('toasts.success_update_habits'),
                                description: this.$t('toasts.success_update_habits_desc'),
                            });
                            setTimeout(() => {
                                this.success = false
                            }, 5000);
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        }
    }
}
</script>
